import { Injectable } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../../../services/storage/storage.service';
import { Definitions } from '../../../core/definitions';
import { SearchRequestPayload } from '../../../core/interfaces/search.interface';

@Injectable()
export class SearchHistoryService {
  modifySearchBS = new BehaviorSubject<any>(null);

  private _searchHistory = new BehaviorSubject<any>(null);

  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
    private _storageService: StorageService,
  ) {}

  get searchHistory$(): Observable<any> {
    if (!this._searchHistory.getValue()) {
      this.getSearchHistory()
        // .pipe(() => this._searchHistory.asObservable())
        .subscribe((response) => {
          if (response.status === 'OK') {
            this._searchHistory.next(response.data);
          }
        });
    } else {
      return this._searchHistory.asObservable();
    }
  }

  // -------------- behavioral subjects -----------------------

  setModifySearchBSBS(value) {
    this.modifySearchBS.next(value);
  }
  getModifySearchBSBS() {
    return this.modifySearchBS.asObservable();
  }

  // ----------------- services -----------------

  getSearchHistory(): Observable<any> {
    const url = `${this._configService.searchApi}/SearchHistory/GetSearchHistory`;
    return this._apiService.get(url);
  }

  clearSearchHistory(): Observable<any> {
    const url = this._configService.searchApi + '/SearchHistory/ClearSearchHistory';
    return this._apiService.get(url);
  }

  getHistoryCached(): SearchRequestPayload {
    return this._storageService.getItem(Definitions.searchHistorySessionKey);
  }

  setHistoryCached(data: SearchRequestPayload) {
    this._storageService.setItem(Definitions.searchHistorySessionKey, data);
  }
}
